import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "klickl-pay-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      label: _ctx.expand ? `+${_ctx.expand}` : '',
      "label-width": _ctx.expand ? '42px' : '0px',
      "label-align": "center",
      placeholder: _ctx.placeholder,
      modelValue: _ctx.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => (_ctx.value = $event)),
        _ctx.onInputHandler
      ],
      "left-icon": "coupon-o",
      maxlength: "30",
      type: _ctx.type,
      "right-icon": _ctx.value && 'clear',
      onClickRightIcon: _ctx.clear
    }, null, 8, ["label", "label-width", "placeholder", "modelValue", "type", "right-icon", "onUpdate:modelValue", "onClickRightIcon"])
  ]))
}